import { render } from "./cropperUpload.vue?vue&type=template&id=52316df2"
import script from "./cropperUpload.vue?vue&type=script&lang=js"
export * from "./cropperUpload.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__